import { type Jast, walkAST, print } from '@atlaskit/jql-ast';
import type { TextSearchInputClauseType } from '../../common/types.tsx';
import { IsInCompoundClauseVisitor } from '../is-in-compound-clause-visitor.tsx';

/**
 * Removes a specific field from the JQL AST without removing it from the text search input.
 */
export const removeFieldsFromJql = (
	ast: Jast,
	clausesToRemove: Set<string>,
	textSearchInputClause?: TextSearchInputClauseType,
): string => {
	walkAST(
		{
			enterTerminalClause(terminalClause) {
				const isTextSearchInput =
					textSearchInputClause &&
					new IsInCompoundClauseVisitor(terminalClause).visit(textSearchInputClause);

				if (clausesToRemove.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) {
					terminalClause.remove();
				}
			},
		},
		ast,
	);
	return print(ast, {
		operatorCase: 'upper',
	});
};
